import { lazy } from "react";
import { Navigate } from "react-router-dom";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout.js"));

/***** Pages ****/

const Starter = lazy(() => import("../views/Starter.js"));

const Families = lazy(() => import("../views/Families.js"));
const Regions = lazy(() => import("../views/Regions.js"));
const Positions = lazy(() => import("../views/Positions.js"));
const ClothingDesigner = lazy(() => import("../views/ClothingDesigner.js"));
const Fonts = lazy(() => import("../views/Fonts.js"));

/*const About = lazy(() => import("../views/About.js"));
const Alerts = lazy(() => import("../views/ui/Alerts"));
const Badges = lazy(() => import("../views/ui/Badges"));
const Buttons = lazy(() => import("../views/ui/Buttons"));
const Cards = lazy(() => import("../views/ui/Cards"));
const Grid = lazy(() => import("../views/ui/Grid"));
const Tables = lazy(() => import("../views/ui/Tables"));
const Forms = lazy(() => import("../views/ui/Forms"));
const Breadcrumbs = lazy(() => import("../views/ui/Breadcrumbs"));*/

/*****Routes******/

const ThemeRoutes = (dropToken) => [
  {
    path: "/",
    element: <FullLayout dropToken={dropToken} />,
    children: [
      { path: "/", element: <Navigate to="/familias" /> },

      { path: "/familias", exact: true, element: <Families /> },
      { path: "/regiones", exact: true, element: <Regions /> },
      { path: "/posiciones", exact: true, element: <Positions /> },
      { path: "/fuentes", exact: true, element: <Fonts /> },
      { path: "/diseno-de-prenda", exact: true, element: <ClothingDesigner /> },


      /*{ path: "/starter", exact: true, element: <Starter /> },
      { path: "/about", exact: true, element: <About /> },
      { path: "/alerts", exact: true, element: <Alerts /> },
      { path: "/badges", exact: true, element: <Badges /> },
      { path: "/buttons", exact: true, element: <Buttons /> },
      { path: "/cards", exact: true, element: <Cards /> },
      { path: "/grid", exact: true, element: <Grid /> },
      { path: "/table", exact: true, element: <Tables /> },
      { path: "/forms", exact: true, element: <Forms /> },
      { path: "/breadcrumbs", exact: true, element: <Breadcrumbs /> },*/
    ],
  },
];

export default ThemeRoutes;
